import React from "react";
import blogImg from "../assets/images/bloggs.webp";
import blog1 from "../assets/images/blog1.png";
import blog2 from "../assets/images/blog2.png";
import blog3 from "../assets/images/blog-3.webp";
import blog4 from "../assets/images/ai-automation.webp";
import blog5 from "../assets/images/blog-5.webp";
import blog6 from "../assets/images/blog-6.webp";
import blog7 from "../assets/images/lead-blog1.webp";
import blog8 from "../assets/images/blog8.webp";

import Client1 from "../assets/clients/digigrow.webp";
import Client2 from "../assets/clients/eduitalent.webp";
import Client3 from "../assets/clients/sankalp.webp";
import Client4 from "../assets/clients/speedroutes.webp";
import Client5 from "../assets/clients/devrishi.webp";
import Client6 from "../assets/images/vmdata.webp";

import { FiArrowRight } from "react-icons/fi";
import { Link } from "react-router-dom";

function Blogsection() {
  // seo----------------------------------------------------
  const blogcantainerrData = [
    {
      id: 1,
      category: "SEO",
      title:
        "Google SGE Explained: How Search is Changing in 2026 & What to Do",
      image: blog3,
      link: "/google-sge-explained-how-search-is-changing-in-2026-and-what-to-do",
      date: "2026-04-24",
    },
    {
      id: 2,
      category: "SEO",
      title:
        "Why Your Website is Not Ranking on Google and How to Fix It Fast (2026 Guide)",
      image: blog2,
      link: "/why-your-website-is-not-ranking-on-google-and-how-to-fix-it-fast-2026-guide",
      date: "2026-04-21",
    },
    {
      id: 3,
      category: "SEO",
      title:
        "Low Website Traffic? 10 Proven Ways to Increase Organic Traffic in 30 Days",
      image: blog1,
      link: "/low-website-traffic-10-proven-ways-to-increase-organic-traffic-in-30-days",
      date: "2026-04-15",
    },
  ];
  // ai ----------------------------------------------------
  const blogcantaineraiData = [
    {
      id: 3,
      category: "Artificial Intelligence",
      title: "How AI Can Grow Your Business Faster (Complete Guide 2026)",
      image: blog6,
      link: "/how-ai-can-grow-your-business-faster",
      date: "2026-05-02",
    },
    {
      id: 2,
      category: "Artificial Intelligence",
      title: "One AI Tool That Can Fully Automate Your Entire Business",
      image: blog5,
      link: "/one-ai-tool-that-can-fully-automate-your-entire-business",
      date: "2026-04-30",
    },
    {
      id: 1,
      category: "Artificial Intelligence",
      title:
        "What is Artificial Intelligence? Complete Guide for Beginners (2026)",
      image: blog4,
      link: "/what-is-artificial-intelligence-complete-guide-for-beginners-2026",
      date: "2026-04-28",
    },
  ];
// lead genertaion-----------------------------
  const blogcantainerleadData = [
  
    {
      id: 2,
      category: "Lead Generation",
      title: "LinkedIn Lead Generation in 2026: Advanced Strategies That Actually Work",
      image: blog8,
      link: "/linkedin-b2b-lead-generation-strategies-2026",
      date: "2026-05-14",
    },

    {
      id: 1,
      category: "Lead Generation",
      title:
        "Why 90% of Marketers Fail at Lead Generation in 2026",
      image: blog7,
      link: "/why-marketers-fail-lead-generation-2026",
      date: "2026-05-04",
    },

  ];

  return (
    <div>
      <section className="blogall">
        <div className="blogall-content">
          <h1>Digital Marketing & SEO Blogs to Grow Your Business</h1>
          <p>
            Welcome to our Digital Marketing Blog where we share expert insights
            on SEO, PPC, Web Development, Lead Generation and Online Growth
            Strategies. If you're looking to grow your business online, our blog
            provides actionable tips, latest trends, and proven techniques to
            increase traffic and conversions.
          </p>
          <Link to="/contact">
            <button className="blogall-btn">Get Free Consultation →</button>
          </Link>
        </div>

        <div className="blogall-image">
          <img src={blogImg} alt="Business Growth" />
        </div>
      </section>

      <div>
        <div className="breadcrumb">
          <Link to="/">Home</Link>
          <span> / </span>
          <span>Blog</span>
        </div>
      </div>

      <section className="blog-section-with-form">
        <div className="blog-left-area">
          <section className="blog-cantainer">
            <h2 className="blog-cantainer-heading">All Blogs</h2>

            <p className="blog-cantainer-para">
              Discover expert insights on SEO, digital marketing, and web
              development. Our blog shares strategies, trends, and tips to boost
              traffic, generate leads, and grow your online business
              effectively.
            </p>

            {/* seo section----------------------------------  */}
            <div className="blog-cantainer-row-1">
              <h2>Search Engine Optimization </h2>

              {blogcantainerrData.map((blog) => (
                <Link to={blog.link} key={blog.id} className="blog-link">
                  <div className="blog-cantainer-card-1">
                    <img
                      src={blog.image}
                      alt={blog.title}
                      className="blog-cantainerr-img"
                    />

                    <div className="blog-cantainerr-content">
                      <span className="blog-cantainerr-category">
                        {blog.category}
                      </span>
                      <h3>{blog.title}</h3>
                      <div className="blog-date">
                        Published:{" "}
                        {new Date(blog.date).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })}
                      </div>
                    </div>

                    <div className="blog-arrow">
                      <FiArrowRight />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
            {/* ai ------------------------------------------- */}
            <div className="blog-cantainer-row-1">
              <h2>AI & Marketing Automation </h2>

              {blogcantaineraiData.map((blog) => (
                <Link to={blog.link} key={blog.id} className="blog-link">
                  <div className="blog-cantainer-card-1">
                    <img
                      src={blog.image}
                      alt={blog.title}
                      className="blog-cantainerr-img"
                    />

                    <div className="blog-cantainerr-content">
                      <span className="blog-cantainerr-category">
                        {blog.category}
                      </span>
                      <h3>{blog.title}</h3>
                      <div className="blog-date">
                        Published:{" "}
                        {new Date(blog.date).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })}
                      </div>
                    </div>

                    <div className="blog-arrow">
                      <FiArrowRight />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
            {/* Lead Generation------------------------------- */}
            <div className="blog-cantainer-row-1">
              <h2>Lead Generation</h2>

              {blogcantainerleadData.map((blog) => (
                <Link to={blog.link} key={blog.id} className="blog-link">
                  <div className="blog-cantainer-card-1">
                    <img
                      src={blog.image}
                      alt={blog.title}
                      className="blog-cantainerr-img"
                    />

                    <div className="blog-cantainerr-content">
                      <span className="blog-cantainerr-category">
                        {blog.category}
                      </span>
                      <h3>{blog.title}</h3>
                      <div className="blog-date">
                        Published:{" "}
                        {new Date(blog.date).toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        })}
                      </div>
                    </div>

                    <div className="blog-arrow">
                      <FiArrowRight />
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            {/* Keyword-Rich SEO Section */}
            <div className="blog-seo-keywords-section">
              <h2>Popular Topics & Services</h2>
              <div className="keywords-grid">
                <div className="keyword-item">
                  <h3>Lead Generation Services</h3>
                  <p>
                    B2B lead generation, qualified leads, lead nurturing,
                    conversion optimization
                  </p>
                </div>
                <div className="keyword-item">
                  <h3> SEO Services 2026</h3>
                  <p>
                    Technical SEO, local SEO, enterprise SEO, semantic search
                    optimization
                  </p>
                </div>
                <div className="keyword-item">
                  <h3> AI Marketing Automation</h3>
                  <p>
                    Marketing automation platforms, email automation, CRM
                    integration
                  </p>
                </div>
                <div className="keyword-item">
                  <h3> Business Automation</h3>
                  <p>
                    Workflow automation, process optimization, efficiency
                    improvement
                  </p>
                </div>
                <div className="keyword-item">
                  <h3> Web Development</h3>
                  <p>
                    Custom websites, e-commerce, responsive design, progressive
                    web apps
                  </p>
                </div>
                <div className="keyword-item">
                  <h3> Content Writing</h3>
                  <p>
                    SEO content, blog writing, copywriting, technical
                    documentation
                  </p>
                </div>
                <div className="keyword-item">
                  <h3> UI/UX Design</h3>
                  <p>
                    User interface design, user experience, mobile app design,
                    prototyping
                  </p>
                </div>
                <div className="keyword-item">
                  <h3> Branding Services</h3>
                  <p>
                    Brand identity, logo design, brand strategy, visual identity
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div className="blog-right-area">
          <div className="callback-form">
            <h3>Request a Call back Now</h3>
            {/* <form>
              <input type="text" placeholder="Name *" required />
              <input type="email" placeholder="Email Id *" required />
              <input type="tel" placeholder="Mobile No *" required />
              <select required>
                <option value="">Choose Services</option>
                <option>SEO Services</option>
                <option>Google Ads</option>
                <option>Social Media Marketing</option>
                <option>Web Development</option>
                <option>AI Marketing Automation</option>
                <option>Lead Generation</option>
                <option>Business Automation</option>
                <option>UI/UX Design</option>
                <option>Content Writing</option>
                <option>Branding Services</option>
              </select>
              <textarea placeholder="Type Your Message"></textarea>
              <button type="submit" className="submit-now">
                Submit Now →
              </button>
            </form> */}
            <form>
              <div className="form-group">
                <label htmlFor="name">Name *</label>

                <input id="name" type="text" required />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Id *</label>
                <input id="email" type="email" required />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Mobile No *</label>
                <input id="phone" type="tel" required />
              </div>

              <div className="form-group">
                <label htmlFor="service">Choose Service *</label>
                <select id="service" required>
                  <option value="">Select Service</option>
                  <option value="seo">SEO Services</option>
                  <option value="ads">Google Ads</option>
                  <option value="smm">Social Media Marketing</option>
                  <option value="web">Web Development</option>
                  <option value="ai">AI Marketing Automation</option>
                  <option value="lead">Lead Generation</option>
                  <option value="automation">Business Automation</option>
                  <option value="uiux">UI/UX Design</option>
                  <option value="content">Content Writing</option>
                  <option value="branding">Branding Services</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">Your Message</label>
                <textarea id="message"></textarea>
              </div>

              <button type="submit" className="submit-now">
                Submit Now →
              </button>
            </form>

            <div className="experience-box">
              <h3>Experience Results That Matter!</h3>
              <p>
                Discover how we boosted our clients' search visibility and
                business growth.
              </p>
              <button className="case-btn">View Case Studies →</button>
            </div>

            <div className="clients-box">
              <h3>Our Key Clients</h3>
              <div className="clients-grid">
                <img src={Client1} alt="DigiGrow" />
                <img src={Client2} alt="EduiTalent" />
                <img src={Client3} alt="Sankalp" />
                <img src={Client4} alt="SpeedRoutes" />
                <img src={Client5} alt="SpeedRoutes" />
                <img src={Client6} alt="VMDATA" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Blogsection;
